"use client";

import { c as _c } from "react/compiler-runtime";
import { Toaster as ChakraToaster, Portal, Spinner, Stack, Toast, createToaster } from "@chakra-ui/react";
import * as toast from "@zag-js/toast"; // TODO: remove this if not needed (`toast` can likely use type inference instead)
import LinkIcon from "../../img/icon-link.svg";
import { ReactNode } from "react";
export const toaster = createToaster({
  placement: "top",
  pauseOnPageIdle: true
});
const ToasterIcon = t0 => {
  const $ = _c(3);
  const {
    type: t1
  } = t0;
  const type = t1 === undefined ? "info" : t1;
  switch (type) {
    case "loading":
      {
        let t2;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <Spinner size="sm" color="blue.solid" />;
          $[0] = t2;
        } else {
          t2 = $[0];
        }
        return t2;
      }
    case "link":
      {
        let t2;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <LinkIcon />;
          $[1] = t2;
        } else {
          t2 = $[1];
        }
        return t2;
      }
    default:
      {
        let t2;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <Toast.Indicator />;
          $[2] = t2;
        } else {
          t2 = $[2];
        }
        return t2;
      }
  }
};
export const Toaster = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Portal><ChakraToaster toaster={toaster}>{_temp}</ChakraToaster></Portal>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(toast) {
  return <Toast.Root width={{
    md: "lg"
  }} insetInline={{
    mdDown: "4"
  }} borderRadius="xl" bg={toast.type === "error" || toast.type === "warning" ? "warning" : "white"}><ToasterIcon type={toast.type} /><Stack gap="1" flex="1" maxWidth="full">{toast.title && <Toast.Title>{toast.title}</Toast.Title>}{toast.description && <Toast.Description>{toast.description}</Toast.Description>}</Stack>{toast.action && <Toast.ActionTrigger>{toast.action.label}</Toast.ActionTrigger>}{toast.closable && <Toast.CloseTrigger />}</Toast.Root>;
}